import React from "react";
import { motion } from "framer-motion";
import { FadeUp, SectionLabel } from "./Motion";
import { useContent } from "../context/ContentContext";

const Services = () => {
  const { content } = useContent();
  const services = content.services || [];
  return (
    <section id="services" className="relative py-28 md:py-40 bg-[#FAFAFA]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <FadeUp><SectionLabel num="04">What we cover</SectionLabel></FadeUp>
        <div className="mt-8 md:mt-12 grid grid-cols-1 md:grid-cols-12 gap-8">
          <FadeUp delay={0.05} className="md:col-span-8">
            <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-[-0.02em] text-black">
              Our disciplines.<br />
              <span className="font-semibold">Our uncompromised and customised craft.</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.15} className="md:col-span-4 md:pt-3 text-zinc-600">
            Every policy is hand-architected by our in-house specialists. No off-the-shelf templates. No filler clauses.
          </FadeUp>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((s, i) => (
            <motion.article key={s.title + i}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className="group relative rounded-3xl bg-white border border-black/5 p-8 md:p-10 hover:border-black/30 transition-all duration-500 hover:-translate-y-1"
              data-testid={`service-${i}`}
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-[11px] uppercase tracking-[0.28em] text-zinc-400">0{i + 1}</span>
                <span className="text-black opacity-0 group-hover:opacity-100 transition-opacity duration-500" aria-hidden>→</span>
              </div>
              <h3 className="font-display text-3xl md:text-4xl font-medium text-black mt-10">{s.title}</h3>
              <p className="mt-4 text-zinc-600 text-base leading-relaxed">{s.desc}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
